import upload from '@_system/components/formcomponents/common/upload/index.vue'
export default {
	props: {

	},
	data() {
		return {
			list_autorender: true,
			list_sourcedata: [],
			list_gridOptions: null,
			list_foreingKey: {},
			list_formConfig: [{
					field: 'a',
					title: 'A',
					itemRender: {
						name: '$input'
					}
				},
				// {
				// 	title: '操作',
				// 	fixed: "right",
				// 	align: 'center',
				// 	width: 65,
				// 	slots: {
				// 		default: ({row}) => {
				// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
				// 		}
				// 	}
				// }
			],
			list_columns: [{
					field: 'a',
					title: 'A'
				},
				{
					field: 'b',
					title: 'B'
				}
			],
			list_formButton: [],
			// list_formButton: [{
			// 	align: 'left',
			// 	span: 24,
			// 	itemRender: {
			// 		name: '$tableformbutton',
			// 		props: {
			// 			table: this
			// 		}
			// 	}
			// }],
			// list_formButton: [{
			// 	itemRender: {
			// 		name: '$button',
			// 		children: [{
			// 			props: {
			// 				type: 'submit',
			// 				content: '查询',
			// 				status: 'primary'
			// 			}
			// 		}, {
			// 			props: {
			// 				type: 'reset',
			// 				content: '重置'
			// 			}
			// 		}]
			// 	}
			// }],
			list_footerField: [],
		}
	},
	created() {
		if (this.list_autorender) {
			this.list_init()
		}

	},
	methods: {
		list_init() {
			this.init_formButton()
			let list_gridOptions = this.list_getOption()
			const beforeCreateResult = this.list_beforeCreateGrid(list_gridOptions)
			if (beforeCreateResult && typeof beforeCreateResult.then === 'function') {
				beforeCreateResult.then(() => {
					this.list_gridOptions = list_gridOptions
				})
			} else {
				this.list_gridOptions = list_gridOptions
			}
		},
		
		init_formButton() {
			if (this.list_formConfig.length <= 3) {
				this.list_formButton = [{
					itemRender: {
						name: '$buttons',
						children: [{
							props: {
								type: 'submit',
								content: '查询',
								status: 'primary'
							}
						}, {
							props: {
								type: 'reset',
								content: '重置'
							}
						}]
					}
				}]
			} else {

				this.list_formButton = [{
					align: 'left',
					span: 24,
					itemRender: {
						name: '$tableformbutton',
						props: {
							table: this
						}
					}
				}]
			}
		},
		list_initcolumns() {
			let columns = []
			this.list_columns.forEach((item) => {
				if(item.field && typeof item.formatter == 'string'){
					let obj = JSON.parse(JSON.stringify(item))
					obj.formatter = (item.formatter && item.formatter != 'file') ? ({
						row
					}) => {
						return window.systemMethods.formatter(row, item)
					} : obj.formatter
					
					if(item.formatter == 'file'){
						obj.slots = {}
						obj.slots.default = ({row})=>{
							return <upload value={row[item.field]?row[item.field]:[]} readonly />
						}
					}
					columns.push(obj)
				}else{
					columns.push(item)
				}
			})
		
			return columns
		},
		list_beforeCreateGrid() {

		},
		list() {
			return new Promise((resolve) => {
				let data = {}
				data.list = []
				resolve(data)
			})
		},

		list_getColumns() {
			return this.list_initcolumns()
		},
		list_getOption() {
			return {
				// scrollX:{
				// 	enabled:true
				// },
				// scrollY:{
				// 	enabled:true,
				// 	gt:20
				// },
				id: 'list',
				border: true,
				size: 'mini',
				headerRowClassName: "headerRowClassName",

				columns: this.list_getColumns(),
				editConfig: {
					trigger: 'click',
					mode: 'cell',
					showStatus: true,
					showIcon: true
				},
				columnConfig: {
					isHover: false,
					resizable: true
				},
				customConfig: {
					storage: true
				},
				toolbarConfig: {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '导出',
						status: 'success',
						code: 'export'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				},
				rowConfig: {
					isHover: true,
					isCurrent: true,
				},
				tooltipConfig: {
					showAll: true,
					enterable: true,
					contentMethod: ({
						row,
						column
					}) => {
						if (row && column.field) {
							return row[column.field]
						} else {
							return ''
						}
					}
				},
				filterConfig: {
					remote: false,
				},
				treeConfig: {
					lazy: true,
					transform: true,
					rowField: 'id',
					parentField: 'parentid',
					line: false,
					expandAll: false,
				},
				importConfig: {
					types: ['xls', 'xlsx'],
					remote: true,
					importMethod: this.list_importMethod
				},
				validConfig: {
					showMessage: false
				},
				footerCellClassName: 'footerCellColor',
				showFooter: this.list_footerField.length > 0 || Boolean(this.statisticsfield),
				footerMethod: this.list_footerMethod,
				resizable: true,
				keepSource: true,
				showOverflow: true,
				height: 'auto',
				formConfig: {
					titleWidth: '80',
					titleAlign: 'center',
					items: this.list_formConfig.length > 0 ? this.list_formConfig.concat(this.list_formButton) : [],
					span: 8
				},
				pagerConfig: {
					enabled: false,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500],
				},
				exportConfig: {
					name: '导出',
					type: 'xlsx'
				},
				proxyConfig: {
					autoLoad: true,
					form: true,
					ajax: {
						query: ({
							page,
							form
						}, other) => {
							let updateForm = this.list_initupdateform(form)

							//console.log(form,JSON.parse(JSON.stringify(form)),123123)

							if (this.beforeRequest) {
								this.beforeRequest(updateForm, page)
							}
							return new Promise(resolve => {
								this.list(page, updateForm, other).then((res) => {
									if (this.beforeRender) {
										this.beforeRender(res)
									}
									if (res) {
										let resolveobj = {
											result: res.list,
											page: {
												total: res.total
											}
										}
										if (this.list_gridOptions.pagerConfig.enabled === false) {
											resolveobj = res.list
										}
										resolve(resolveobj)
									} else {
										resolve()
									}
								}, () => {
									resolve()
								})
							})
						}
					}
				},
				sortConfig: {
					remote: false
				}
			}
		},
		list_initupdateform(form) {
			let updateForm = JSON.parse(JSON.stringify(form))
			for (let i in updateForm) {
				if (i.toUpperCase().match(/.*TIME/g) || i.toUpperCase().match(/.*DATE/g)) {
					if (typeof updateForm[i] === 'string') {
						updateForm[i] = updateForm[i].split(',')
					}
					if (typeof updateForm[i] === 'number') {
						if (updateForm[i] > 1000000000000) {
							updateForm[i] = parseInt(updateForm[i] / 1000)
						}
					} else if (Array.isArray(updateForm[i])) {
						let timerange = updateForm[i]
						timerange.forEach((t, i) => {
							if (t > 1000000000000) {
								timerange[i] = parseInt(t / 1000)
							} else {
								timerange[i] = t
							}
						})
						updateForm[i] = updateForm[i].join(',')
					}
				} else {
					if (Array.isArray(updateForm[i])) {
						if (!Array.isArray(updateForm[i][0])) {
							updateForm[i] = updateForm[i].join(',')
						} else {
							let lastvaluearr = []
							updateForm[i].forEach((value) => {
								lastvaluearr.push(value[value.length - 1])
							})
							updateForm[i] = lastvaluearr.join(',')
						}

						//updateForm[i] = updateForm[i].join(',')
					}
				}
			}
			return updateForm
		},
		list_batchsettablevalue(param = {}, data = []) {
			data.forEach((item) => {
				for (let i in param) {
					item[i] = param[i]
				}

			})
		},
		list_toolbarButtonClickEvent(e) {
			if (this[e.code]) {
				this[e.code]()
			}
		},
		list_footerMethod({
			columns,
			data
		}) {
			let footData = []
			columns.forEach((item) => {
				if (item.type == 'seq') {
					footData.push('合计')
				} else {
					let obj = this.list_footerField.find((obj) => {
						return obj.field == item.field
					})
					if (obj) {
						let res = 0
						if (!obj.value) {
							res = this.list_sum(item.field, data, obj.toFixed)
						} else {
							res = obj.value
						}
						if (obj.format) {
							res = window.systemMethods.formatNumber(parseFloat(res))
						}
						footData.push(res)
					} else {
						footData.push('')
					}
				}
			})
			//console.log(columns, data)

			return [
				footData
			]
		},
		list_sum(field, data, toFixed) {
			let sum = 0
			if (this.statisticsfield) {
				if (this.sourcestatisticsdata[field]) {
					sum = this.sourcestatisticsdata[field]
				}
				return sum
			} else {
				data.forEach((item) => {
					for (let i in item) {
						if (i == field) {
							sum = sum + (isNaN(parseFloat(item[i])) ? 0 : parseFloat(item[i]))
						}
					}
				})
				return sum.toFixed(toFixed)
			}

		},
		list_importMethod(e) {
			let table = e.$table
			this.loading = true
			let file = e.file
			let reader = new FileReader();
			reader.onload = (e) => {
				let data = e.target.result
				let workbook = this.$XLSX.read(data, {
					type: 'binary',
				})
				let sheetName = workbook.SheetNames[0];
				let worksheet = workbook.Sheets[sheetName]
				let jsonData = this.$XLSX.utils.sheet_to_json(worksheet, {
					raw: false
				})
				let tablecolumns = this.$Lodash.groupBy(table.getColumns(), 'title')
				table.reloadData([]).then(() => {
					let insertData = []
					jsonData.forEach((item) => {
						let obj = {
							id: Math.random()
						}
						for (let i in item) {
							if (tablecolumns[i]) {
								let columns = tablecolumns[i][0]
								if (columns.editRender) {
									this.list_importEditRanderParse(columns, item[i], obj)
								} else {
									obj[columns.field] = item[i]
								}
							}
						}
						for (let i in tablecolumns) {
							if (tablecolumns[i][0].field) {
								if (obj[tablecolumns[i][0].field] === null || obj[tablecolumns[i][0]
										.field] === undefined) {
									obj[tablecolumns[i][0].field] = null
								}
							}
						}
						//console.log(obj)
						insertData.push(obj)
					})
					table.reloadData(insertData)
					//console.log(insertData)
					//this.$refs[this.importTableRef].insertAt(insertData)
				})
				this.loading = false
			}
			reader.readAsBinaryString(file)
		},
		list_importEditRanderParse(columns, value, obj) {
			if (columns.editRender.name == '$emun') {
				obj[columns.field] = window.systemMethods.getEmunId(columns.editRender.props.name, value)
			} else if (columns.editRender.name == '$select') {
				let selectoptions = columns.editRender.props.selectoptions
				let options = selectoptions.find((optionsitem) => {
					return optionsitem.label == value
				})
				//console.log(options)
				if (options) {
					obj[columns.field] = options.value
				} else {
					obj[columns.field] = 10
				}
				//console.log(selectoptions)
			} else if (columns.editRender.name == '$datePicker') {
				if (this.list_importisNumeric(value) && value < 1000000000) {
					value = this.list_GMTdate2date(value)
				}

				obj[columns.field] = this.$Moment(value).valueOf()
			} else if (columns.editRender.name.startsWith('$') && columns.editRender.props.moduleName) {
				if (!columns.editRender.name.startsWith('$input')) {
					//console.log(columns.editRender.props.moduleName)
					obj[columns.field] = window.systemMethods['get' + columns.editRender.props.moduleName](value,
						'label')
				}
			} else if (this.list_custom_importEditRanderParse) {
				this.list_custom_importEditRanderParse(columns, value, obj)
			} else {
				obj[columns.field] = value
			}
		},
		list_GMTdate2date(serial) {
			const startDate = new Date(1900, 0, 1); // 1900-01-01
			const days = serial - 1; // Excel 的 1 = 1900-01-01
			const milliseconds = days * 86400 * 1000; // 1 天 = 86400 秒 * 1000 毫秒
			const date = new Date(startDate.getTime() + milliseconds);
			// 修正 Excel 的 1900 闰年错误（Excel 错误地认为 1900 是闰年）
			//if (serial >= 60) date.setDate(date.getDate());
			//console.log(date)
			return date.toISOString().split('T')[0]
		},
		list_importisNumeric(value) {
			return (
				(typeof value === 'number' && !isNaN(value)) || // 基本类型数字
				(typeof value === 'string' && !isNaN(parseFloat(value))) // 字符串数字
			)
		},
	},

	components: {
		upload,

	}


}